import DOMPurify from 'isomorphic-dompurify';
import { sanitizeAttributeHook, unsanitizeAttributes } from './utilities/safe-element-attribute-sanitizers.mjs';
import { encodeDangerousElementHook, unsanitizeEncodedElements } from './utilities/dangerous-element-sanitizers.mjs';
import { domDiff } from './utilities/dom-diff.mjs';

(function initializeHooks() {
  DOMPurify.removeAllHooks();
  DOMPurify.addHook('uponSanitizeElement', encodeDangerousElementHook);
  DOMPurify.addHook('uponSanitizeAttribute', sanitizeAttributeHook);
})();
function sanitize(dirtyHTMLString, options = {}) {
  const sanitizeArgs = {
    ADD_TAGS: ['iframe', '#comment'],
    FORCE_BODY: true,
    USE_PROFILES: {
      svg: true,
      svgFilters: true,
      html: true
    },
    ALLOW_UNKNOWN_PROTOCOLS: true,
    FORBID_TAGS: [],
    ...options
  };
  const sanitizedContent = DOMPurify.sanitize(dirtyHTMLString, sanitizeArgs);
  if (options.diffCallback) {
    const restoredContent = unsanitize(sanitizedContent);
    domDiff(dirtyHTMLString, restoredContent, options.diffCallback);
  }
  return sanitizedContent;
}
function unsanitize(sanitizedHTMLString) {
  const parser = new DOMParser();

  // Wrap in body tag to fix bug in DOMParser where if the HTML
  // String starts with a comment, the comment will get removed.
  // See PR #31091 for context
  const htmlDoc = parser.parseFromString(`<body>${sanitizedHTMLString}</body>`, 'text/html');
  const domWalker = htmlDoc.createTreeWalker(htmlDoc.body, NodeFilter.SHOW_ELEMENT);
  let currentNode = domWalker.currentNode;
  let nextNode = null;
  while (currentNode) {
    nextNode = domWalker.nextNode();
    unsanitizeEncodedElements(currentNode);
    unsanitizeAttributes(currentNode);
    currentNode = nextNode;
  }
  return htmlDoc.body.innerHTML;
}

export { sanitize, unsanitize };
